import { Link } from 'react-router-dom';
import Reveal from '../components/Reveal.jsx';
import ServiceAdvisor from '../components/ServiceAdvisor.jsx';
import { PILLARS, PRINCIPLES } from '../content/site.js';

export default function Services() {
  return (
    <>
      <section className="page-head">
        <div className="shell">
          <p className="eyebrow">What we offer</p>
          <h1>Services</h1>
          <p className="lede" style={{ marginTop: '1.2rem' }}>
            Three core pillars of IT excellence, delivered with precision and accountability.
          </p>
        </div>
      </section>

      <section className="section" style={{ paddingBottom: 0 }}>
        <div className="shell">
          <Reveal><ServiceAdvisor /></Reveal>
        </div>
      </section>

      {PILLARS.map((p) => (
        <section className="section" id={p.slug} key={p.slug} style={{ scrollMarginTop: '5rem' }}>
          <div className="shell">
            <Reveal>
              <p className="eyebrow">{p.eyebrow}</p>
              <h2>{p.title}</h2>
              <p className="lede" style={{ marginTop: '1rem' }}>{p.lede}</p>
            </Reveal>
            <div className="grid grid-3" style={{ marginTop: '2.5rem' }}>
              {p.items.map(([name, body], i) => (
                <Reveal key={name} delay={i * 60}>
                  <div className="card">
                    <h3>{name}</h3>
                    <p className="dim" style={{ marginTop: '0.6rem' }}>{body}</p>
                  </div>
                </Reveal>
              ))}
            </div>
            <p style={{ marginTop: '2rem' }}>
              <Link className="btn btn-ghost" to={`/contact?subject=${encodeURIComponent(p.eyebrow)}`}>
                Inquire about this service
              </Link>
            </p>
          </div>
        </section>
      ))}

      <section className="section">
        <div className="shell">
          <Reveal>
            <p className="eyebrow">Why Ennoveda</p>
            <h2>Brilliance at the basics</h2>
            <p className="lede" style={{ marginTop: '1rem' }}>
              We believe the foundation of every great IT strategy is getting the fundamentals
              right. No shortcuts, no buzzwords — just solid, reliable IT excellence.
            </p>
          </Reveal>
          <div className="grid grid-3" style={{ marginTop: '2.5rem' }}>
            {PRINCIPLES.map(([title, body], i) => (
              <Reveal key={title} delay={i * 80}>
                <div className="card">
                  <h3>{title}</h3>
                  <p className="dim" style={{ marginTop: '0.6rem' }}>{body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="shell">
          <Reveal className="cta">
            <h2>Ready to get started?</h2>
            <p className="lede" style={{ marginTop: '1rem' }}>
              Let's discuss how Ennoveda can strengthen your IT posture and accelerate your
              digital initiatives.
            </p>
            <div className="hero-actions" style={{ marginTop: '1.8rem' }}>
              <Link to="/contact" className="btn btn-primary">Schedule a consultation</Link>
              <Link to="/checker" className="btn btn-ghost">Check your domain first</Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
